<template>
  <div class="master-toko">
    <header-page>
      <span
        class="size14 fw-bold-700"
        style="color: #0B5FFF;margin-right: 5px;"
      >Master</span>
      <span
        class="text-dark text-darken-5"
        style="margin-right: 5px;"
      >></span>
      <span class="text-dark fw-bold-400 size14">Cabang</span>
    </header-page>

    <Table
      :result="result"
      :delete-data="deleteData"
      :get-data="getData"
      :edit-item="editItem"
      @filterBank="getFilter"
    />

    <Modal
      :form-data="formPayload"
      :create-item="createItem"
      :edit-id="editId"
      :edit-item="editItem"
      :update-item="updateItem"
      :clean-up-form="cleanUpForm"
      :photo="photo"
      :messages="messages"
      :isLoading="isLoading"
      @getPayload="getPayload"
    />

  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash'
import {
  VBToggle,
} from 'bootstrap-vue'
import { checkPermission, successNotification, errorNotification } from '@/auth/utils'

import HeaderPage from '@/components/HeaderPage.vue'
import Modal from '@/components/Master/Cabang/Modal/Modal.vue'
import Table from '@/components/Master/Cabang/Table.vue'

export default {
  title() {
    return 'Master Cabang'
  },
  components: {
    HeaderPage,
    Table,
    Modal,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      currentPage: 1,
      isLoading: true,
      result: {},
      validations: [],
      editId: null,
      photo: null,
      formPayload: {
        name: '',
        city: '',
        photo: '',
        address: '',
      },
      filter: {
        search: '',
        per_page: 10,
        sort_type: 'asc',
      },
      messages: {},
    }
  },
  setup() {
    return {
      checkPermission,
      successNotification,
      errorNotification,
    }
  },
  watch: {
    filter: {
      handler: _.debounce(function () {
        this.getData()
      }, 300),
      deep: true,
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getPayload(value) {
      this.formPayload = value
    },
    getFilter(value) {
      this.filter = value
    },
    cleanUpForm() {
      this.editId = null
      this.photo = null
      this.formPayload = {
        name: '',
        city: '',
        photo: '',
        address: '',
      }
      this.validations = ''
    },
    editItem(item) {
      this.messages = {}
      this.cleanUpForm()
      this.editId = item.uuid
      this.photo = item.photo_url
      this.$store.commit('cabang/setFormPayload', this.formPayload = {
        name: item.name,
        city: item.city,
        address: item.address,
      })
      this.$bvModal.show('modal-cabang')
    },
    async getData(page = 1) {
      this.isLoading = true
      const queryParams = this.filter
      queryParams.page = page
      this.$store.dispatch('cabang/getData', { uuid: '', params: queryParams }).then(result => {
        this.isLoading = false
        this.result = result.data
        this.currentPage = result.data.current_page
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    createItem() {
      const form = this.preparePayload()
      this.isLoading = true
      this.$store.dispatch('cabang/postData', {
        query: '',
        payload: form,
      })
        .then(() => {
          this.getData()
          successNotification(this, 'Success', 'Cabang berhasil di buat')
          this.cleanUpForm()
          this.$bvModal.hide('modal-cabang')
          this.isLoading = false
        })
        .catch(error => {
          this.messages = error.response.data.meta.messages
          this.isLoading = false
        })
    },
    updateItem() {
      const form = this.preparePayload()
      this.isLoading = true
      form.append('_method', 'PATCH')

      this.$store.dispatch('cabang/postData', {
        query: `${this.editId}`,
        payload: form,
      })
        .then(() => {
          this.getData()
          successNotification(this, 'Success', 'Cabang berhasil di ubah!')
          this.cleanUpForm()
          this.isLoading = false
          this.$bvModal.hide('modal-cabang')
        })
        .catch(error => {
          this.messages = error.response.data.meta.messages
          this.isLoading = false
        })
    },
    async deleteData(uuid) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Are you sure to delete this bank?',
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('cabang/deleteData', `${uuid}`)
            .then(() => {
              this.getData()
              this.$swal({
                icon: 'success',
                title: 'Success!',
                text: 'Cabang berhasil dihapus',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
            .catch(error => {
              if (error.response.data.meta.messages.length > 0) {
                errorNotification(this, 'Oops!', error.response.data.meta.messages)
              }
            })
        }
      })
    },
    preparePayload() {
      const form = new FormData()
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.formPayload) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] != null) {
          form.append(key, this.formPayload[key])
        }
      }
      return form
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';

.px-33 {
  padding-left: 33px;
  padding-right: 33px;
}
.px-16 {
  padding-left: 16px;
  padding-right: 16px;
}
.py-16 {
  padding-top: 16px;
  padding-bottom: 16px;
}
.py-18 {
  padding-top: 18px;
  padding-bottom: 18px;
}

#app {
  background: #f6f7fa;
}

.master-toko {
  height: 100vh
}
</style>
